import type { CollapsedEmployeesGroups } from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/CollapsedEmployeesGroups.ts";
import type { Dispatch } from "react";
import type { CollapsedEmployeesGroupsAction } from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/collapsedEmployeesGroupsReducer.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import {
  CollapsedEmployeesGroupsContext,
  CollapsedEmployeesGroupsDispatchContext,
} from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/CollapsedEmployeesGroupsProvider.tsx";

export default function useCollapsedEmployeesGroups(): {
  collapsedGroups: CollapsedEmployeesGroups;
  dispatchCollapsed: Dispatch<CollapsedEmployeesGroupsAction>;
} {
  const collapsedGroups = useDefinedContextValue(
    CollapsedEmployeesGroupsContext,
  );
  const dispatchCollapsed = useDefinedContextValue(
    CollapsedEmployeesGroupsDispatchContext,
  );
  return { collapsedGroups, dispatchCollapsed };
}
